import { ServiceRequestConfig } from '~/services/createService';
import { k2 } from '~/services/serviceInstances';

import {
  ListTasksApiResponse,
  TaskAttributes,
  TaskResponseData,
} from '../../types/k2/ticketTasks';

export type Task = TaskAttributes & { id: string };

type Request = {
  ticketId: string;
};
type ServerResponse = ListTasksApiResponse;

export const listTasksK2 = async (
  request: Request,
  options: ServiceRequestConfig = {},
): Promise<Task[]> => {
  const serverResponse: ServerResponse = await k2.get(
    `/tickets/${request.ticketId}/tasks`,
    {
      params: { stage_id: '*' },
      showErrorToast: true,
      ...options,
    },
  );

  return mapResponse(serverResponse);
};

const mapResponse = (serverResponse: ServerResponse): Task[] => {
  if (!serverResponse?.data?.length) {
    return [];
  }

  return serverResponse.data.map((taskData: TaskResponseData) => ({
    id: taskData.id,
    ...taskData.attributes,
  }));
};
